const USER_STATUS = {
  UNVERIFIED: "UNVERIFIED",
  INCOMPLETE: "INCOMPLETE",
  COMPLETE: "COMPLETE",
  TELEPHONE_CHANGED: "TELEPHONE_CHANGED",
};

const SESSION_COOKIE_TIMEOUT = 24 * 60 * 60 * 1000; // 24 hours
export { USER_STATUS, SESSION_COOKIE_TIMEOUT };
